import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environments';

@Injectable({
  providedIn: 'root'
})
export class CreditsService {
  private BASE_URL = environment.apiUrl + 'api';

  constructor(private http: HttpClient) { }

  getUserCredits(userId: string): Observable<any> {
    const url = `${this.BASE_URL}/credit/${userId}`;
    return this.http.get<any>(url);
  }


}